import { render } from "./Usage.vue?vue&type=template&id=59fddaf2&scoped=true&ts=true"
import script from "./Usage.vue?vue&type=script&lang=ts"
export * from "./Usage.vue?vue&type=script&lang=ts"

import "./Usage.vue?vue&type=style&index=0&id=59fddaf2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59fddaf2"]])

export default __exports__